/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { avatar_user$ref } from "./avatar_user.graphql";
import type { FragmentReference } from "relay-runtime";
declare export opaque type reviews_reviews$ref: FragmentReference;
declare export opaque type reviews_reviews$fragmentType: reviews_reviews$ref;
export type reviews_reviews = $ReadOnlyArray<{|
  +type: ?string,
  +rate: ?number,
  +recommend: ?boolean,
  +comment: ?string,
  +createdAt: ?any,
  +rider: ?{|
    +firstname: ?string,
    +company: ?{|
      +name: ?string
    |},
    +$fragmentRefs: avatar_user$ref,
  |},
  +$refType: reviews_reviews$ref,
|}>;
export type reviews_reviews$data = reviews_reviews;
export type reviews_reviews$key = $ReadOnlyArray<{
  +$data?: reviews_reviews$data,
  +$fragmentRefs: reviews_reviews$ref,
  ...
}>;
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "lang"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "reviews_reviews",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "recommend",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "lang",
          "variableName": "lang"
        }
      ],
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "rider",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstname",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Company",
          "kind": "LinkedField",
          "name": "company",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "avatar_user"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SpaceReview",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = 'c6a915712175bf4d6c46226669050271';

module.exports = node;
